<script setup lang="ts">
import { omit } from "lodash-es";
import { RouterLink, type RouterLinkProps } from "vue-router";

defineProps<RouterLinkProps & { alt?: string }>();
</script>

<template>
  <RouterLink class="icon-button" v-bind="omit($props, ['alt'])">
    <slot />
    <span v-if="alt" class="visually-hidden">{{ alt }}</span>
  </RouterLink>
</template>

<style scoped>
.icon-button {
  border: 1px solid var(--color-primary);
  border-radius: var(--border-radius-md);
  width: 3.5rem;
  aspect-ratio: 1 / 1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--text-color-body);

  &:hover,
  &:focus-visible {
    background-color: var(--color-primary);
    color: var(--text-color-on-primary);
  }
}
</style>
